import { Box } from '@lingoda/ui';

interface Props {
    bg?: string;
}

export const ContentWrapper = ({ children, bg }: React.PropsWithChildren<Props>) => (
    <Box
        component="main"
        sx={{
            display: 'flex',
            flex: '1 0 auto',
            flexDirection: 'column',
            background: bg || 'white',
        }}
    >
        {children}
    </Box>
);
